module.exports = __webpack_public_path__ + "img/LocationIcon.13fa233b.svg";